export default __webpack_public_path__ + "static/fall1 (4)-41fd1893ee3472fbf968ed1055da04bb.jpeg";